module.exports = __webpack_public_path__ + "adb0296ffdaf8507f42fa45199d1701e.mp4";